import { Thread, ThreadUpload } from "./Types";
import ApiService from "./ApiService";
import api from "./api";

export const createThread = async (tenantId: string, signal?: AbortSignal): Promise<string> => {
    const response = await ApiService.post<{ threadId: string }>({ url: `/tenants/${tenantId}/threads`, signal });
    return response.threadId;
}

export const getThreads = async (tenantId: string, signal?: AbortSignal): Promise<Thread[]> => {
    console.log('Fetching threads for TENANT_ID:', tenantId);
    const response = await ApiService.get<Thread[]>({ url: `/tenants/${tenantId}/threads`, signal });
    console.log('Fetched threads:', response);
    return response;
}

export const deleteThread = async (tenantId: string, threadId: string, signal?: AbortSignal): Promise<void> => {
    await ApiService.delete({ url: `/tenants/${tenantId}/threads/${threadId}`, signal });
}

export const renameThread = async (tenantId: string, threadId: string, newTitle: string, signal?: AbortSignal): Promise<void> => {
    await ApiService.patch({ url: `/tenants/${tenantId}/threads/${threadId}`, data: { title: newTitle }, signal });
}

export const uploadThreadDocument = async (tenantId: string, threadId: string, file: File, signal?: AbortSignal): Promise<ThreadUpload> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await api.post<ThreadUpload>(`tenants/${tenantId}/threads/${threadId}/uploads`, formData, {
        signal,
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 300_000,
    });

    return response.data;
}

export const getThreadUploads = async (tenantId: string, threadId: string, signal?: AbortSignal): Promise<ThreadUpload[]> => {
    const response = await ApiService.get<{ uploads: ThreadUpload[] }>({ url: `/tenants/${tenantId}/threads/${threadId}/uploads`, signal });
    return response.uploads;
}